"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const isNodeActive = (type, attrs = undefined) => state => {
    const { $from, to, node } = state.selection;
    if (node) {
        return node.hasMarkup(type, attrs);
    }
    return to <= $from.end() && $from.parent.hasMarkup(type, attrs);
};
exports.default = isNodeActive;
//# sourceMappingURL=isNodeActive.js.map